import { GuaranteedOfferType } from '@appTypes/App.interface'

import { getFormattedMonth } from '@utils/formatter'
import getGuaranteedOfferType from '@utils/getGuaranteedOfferType'

import { ContentProps, ProductDetailType } from './Content.interface'

const purchaseOfferDurationContent = ({
    creditCard,
}: {
    creditCard: ContentProps['creditCard']
}) => {
    const isMarketingOffer =
        getGuaranteedOfferType({
            creditCard,
        }) === GuaranteedOfferType.MarketingOffer

    if (creditCard.offerDetail.durationOfPurchaseRateMonths == null) {
        return null
    }

    return {
        title: `${creditCard.offerDetail.introPurchaseRateAER ?? 0}% Purchase offer duration`,
        value: isMarketingOffer
            ? getFormattedMonth(
                  creditCard.offerDetail.durationOfPurchaseRateMonths
              )
            : `Up to ${getFormattedMonth(
                  creditCard.offerDetail.durationOfPurchaseRateMonths
              )}`,
        detailType: isMarketingOffer
            ? ProductDetailType.GuaranteedExample
            : undefined,
    }
}

export default purchaseOfferDurationContent
